import classNames from "classnames";
import { DateTime } from "luxon";
import {
  DateInput,
  type DateInputProps
} from "../../../../../mantine/dates/DateInput/DateInput";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldDateInputProps
  extends
    CommonFormFieldItemProps,
    Omit<DateInputProps, "type" | "value" | "onChange"> {
  type: "date";
  value?: string | null;
  onChange?: (date: string | null) => void;
}

function FormFieldDateInput({
  helpText,
  highlight,
  isBetaFeature,
  type,
  value,
  warned,
  onChange,
  ...fieldSpecificProps
}: FormFieldDateInputProps) {
  const manualClearable =
    typeof fieldSpecificProps.clearable === "boolean"
      ? fieldSpecificProps.clearable
      : undefined;
  const clearableBecauseRequired =
    typeof fieldSpecificProps.required === "boolean"
      ? !fieldSpecificProps.required
      : undefined;

  return (
    <DateInput
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames("FormFieldDateInput", fieldSpecificProps.className)}
      clearable={manualClearable ?? clearableBecauseRequired}
      defaultValue={undefined}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      rightSection={
        <FormFieldRightSection
          rightSection={fieldSpecificProps.rightSection}
          warned={warned}
        />
      }
      value={value ? DateTime.fromFormat(value, DATE_DISPLAY_FORMAT) : null}
      onChange={(newValue) =>
        newValue
          ? onChange?.(newValue.toFormat(DATE_DISPLAY_FORMAT))
          : onChange?.(null)
      }
    />
  );
}

export { FormFieldDateInput, FormFieldDateInputProps };
